import { likeCommentAxios as request } from '@src/public/utils/request';

/**
 * 点赞
 * @param {string} appId 时间线 appId: 10
 * @param {string} subjectId 主体id
 * @param {number} businessType 业务类型 like: 1 | dingcai: 2 | flower: 3 | candle: 4
 * @param {string} opType INSERT | DEL  点赞 | 取消点赞
 * @returns
 */
export const likeCommentApi = (appId, subjectId, businessType, opType) => {
    return request.post('/likeComment', {
        body: {
            appId,
            subjectId,
            businessType,
        },
        opType,
    });
};
